<template>
<div>

     <v-list-item
        v-for="(item, index) in brands"
        :key="index"
    >
        <v-list-item-avatar>
            <v-icon>
                mdi-cog
            </v-icon>
        </v-list-item-avatar>

        <v-list-item-content>
            <v-list-item-title>
                {{item.internal_label}}
            </v-list-item-title>

            <v-list-item-subtitle
                v-if="item.is_default"
            >
                Default
            </v-list-item-subtitle>
        </v-list-item-content>

        <v-list-item-action>
            <v-menu 
                bottom 
                offset-y  
            >
                <template v-slot:activator="{ on }">
                    <v-icon 
                        v-on="on"
                    >
                        mdi-dots-vertical
                    </v-icon>
                    
                </template>

                <v-list>
                    <v-list-item
                        v-for="(menu_item, menu_item_index) in getMenuItems(item)"
                        :key="menu_item_index"
                        v-on:click="menu_item.action(item)"
                    >
                        <v-list-item-title>{{ menu_item.text }}</v-list-item-title>
                    </v-list-item>
                </v-list>

            </v-menu> 
        </v-list-item-action>
    </v-list-item>

    <m-icon-bar
        v-on:add="onClickAdd"
    />

   
</div>
</template>

<script>
const _ = require('lodash');

const TestData = require("@/js/TestData.js");

export default {
    props: {
        profile: {
            type: Object,
            default: function() { return {}; }
        },
    },

    data() {
        return {
            brands: [],
        }
    },

    mounted () {
        this.update();
    },

    methods: 
    {
        update()
        {
            this.$rc.showSpinner();
            
            this.$rc.rest(
                'LIST: /api/v1/branding/banner',
            
                {
                    'organization_id' : this.profile.organization_account.organization_id
                },
            
                (data) => {
                    this.$rc.hideSpinner();

                    this.brands = data.results;
                },
            
                () => {
                    this.$rc.hideSpinner();
                    this.$rc.alert('Error','Unable to complete API call');
                },
            );
        },

        onClickAdd()
        {
            this.$rc.showSpinner();
            
            this.$rc.rest(
                'PUT: /api/v1/branding/banner/with-defaults',
            
                {
                    'organization_id' : this.profile.organization_account.organization_id,
                    'banner_id' : this.$rc.uuidv4(),
                },
            
                (data) => {
                    this.$rc.hideSpinner();

                    this.update();
                },
            
                () => {
                    this.$rc.hideSpinner();
                    this.$rc.alert('Error','Unable to create new branding');
                },
            );
        },

        getMenuItems(setting)
        {
            if ( setting.is_default )
            {
                return [
                    { 'text' : 'Edit...', 'action' : this.onClickEdit },
                ];
            }

            return [
                    { 'text' : 'Edit...', 'action' : this.onClickEdit },
                    { 'text' : 'Delete...', 'action' : this.onClickDelete },
                    { 'text' : 'Promote to default', 'action' : this.onClickPromote }
                ];
        },

        onClickEdit(item)
        {
            this.$router.push({
                'name': 'edit-banner-branding',
                'params' : {
                    'banner_id' : item.banner_id
                }
            });
        },

        onClickPromote(item)
        {
            this.$rc.showSpinner();
            
            this.$rc.rest(
                'PUT: /api/v1/branding/banner/promote-to-default',
            
                {
                    'banner_id' : item.banner_id
                },
            
                (data) => {
                    this.$rc.hideSpinner();

                    this.$rc.snackbar(item.internal_label+" is now the default banner branding");

                    this.update();
                },
            
                () => {
                    this.$rc.hideSpinner();
                    this.$rc.alert('Error','Unable to promote to default');
                },
            );
        },

        onClickDelete(item)
        {
            // Check if in use
            this.$rc.rest({
                'spinner': false,
                'endpoint': 'LIST: /api/v1/forms',
            
                'params' : {
                        'organization_id': this.$route.params.organization_id,
                        'banner_id': item.banner_id,
                    },
            
                'on_success': (data) => {
                    if (0 == data.results.length) {
                        // Delete
                        this.$rc.confirm(
                            'Confirm Delete Banner Branding',
                            'Permenantly delete the banner branding: ' + item.internal_label,
                            [
                                { 'text': 'Cancel', 'value': 'cancel' },
                                { 'text': 'Delete', 'value': 'delete' },
                            ],

                            (response) => {
                                if (response != 'delete') return;

                                // Do something

                                this.doDelete(item);
                            }
                        );
                    }
                    else {
                        let error_msg = "Banner Branding '" + item.internal_label + "' is in use by the following form(s):";
                        error_msg += "<ul>";
                        {
                            for (let i = 0; i < data.results.length; i++) {
                                let banner = data.results[i];
                                error_msg += "<li>";
                                {
                                    error_msg += banner.internal_label + (banner.is_archived ? " [Archived]" : "");
                                }
                                error_msg += "</li>";
                            }
                        }
                        error_msg += "</ul>";

                        this.$rc.alert(
                            'Unable to Delete: Banner Branding in Use',
                            error_msg
                        );
                    }
                },
            
                'on_error': 'Unable to complete API call',
            });
        },

        doDelete(item)
        {
            this.$rc.showSpinner();
            
            this.$rc.rest(
                'DELETE: /api/v1/branding/banner',
            
                {
                    'banner_id' : item.banner_id
                },
            
                (data) => {
                    this.$rc.hideSpinner();

                    this.$rc.snackbar(item.internal_label+" has been deleted");

                    this.update();
                },
            
                () => {
                    this.$rc.hideSpinner();
                    this.$rc.alert('Error','Unable to promote to default');
                },
            );
        },

    },
}
</script>

<style lang="scss" scoped>

</style>